import { render, staticRenderFns } from "./LgFinderPageLeitor.vue?vue&type=template&id=340fc9a2"
import script from "./LgFinderPageLeitor.vue?vue&type=script&lang=js"
export * from "./LgFinderPageLeitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports